import { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import classNames from "classnames";
import { toast } from "sonner";

import { CCard, CCardBody } from "@coreui/react";

import { phieuChamDiemHHApi } from "src/1/apis/phieu_cham_diem_hang_hoa.api";
import { history } from "src/App";
import { useMobileDevice } from "src/utils/hooks/viewport";

import { FormTable, FormToolbar } from "../../components";
import { defaultValues, resolver } from "../../form";

const DanhSachHangHoaChamDiem = () => {
  //#region Data
  const params = useParams();

  const { data, isError } = useQuery({
    queryKey: ["chi-tiet-danh-gia-de-xuat-hh", params?.id],
    queryFn: () => phieuChamDiemHHApi.getById(params?.id),
    enabled: !!params?.id,
    select: (response) => response?.data?.data,
  });

  if (isError) {
    toast.error("Không thể lấy thông tin đề xuất hàng hóa!");
    history.replace("/quality-of-goods/rating-forms/list");
  }

  const { control, reset } = useForm({
    mode: "all",
    defaultValues,
    resolver,
  });

  const { fields } = useFieldArray({
    control,
    name: "goods",
    keyName: "__id",
  });

  const isMobile = useMobileDevice();
  //#endregion

  useEffect(() => {
    if (data) {
      reset({ ...data });
    }
  }, [data]);

  //#region Render
  return (
    <>
      <CCard className={classNames("toolbar", !isMobile && "sticky")}>
        <CCardBody>
          <FormToolbar control={control} onlyView />
        </CCardBody>
      </CCard>

      <CCard>
        <CCardBody className="px-0 pt-4">
          <FormTable control={control} dataTable={fields} onlyView />
        </CCardBody>
      </CCard>
    </>
  );
  //#endregion
};
export default DanhSachHangHoaChamDiem;
